module.exports = __webpack_public_path__ + "img/logo.c868e917.svg";